import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { accountsEnvironment } from './accounts-environment';
import { CopilotConfigOverride } from './schemas/copilot-config-override.schema';

export function postCopilotConfigOverrides(
  configSettingsId: string,
  configOverrides: CopilotConfigOverride[]
) {
  return fromFetch(
    new Request(accountsEnvironment.configSettingsIdUrl(configSettingsId), {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify({
        configurations: configOverrides,
      }),
    })
  ).pipe(ignoreData());
}
